<template>
  <div class="posts-list">
    <section v-for="postsGroup in postsByYears" :key="postsGroup.year" class="posts-group">
      <h2>{{ postsGroup.year }}</h2>

      <div class="posts-grid">
        <link-to-post
          v-for="post in postsGroup.posts"
          :key="post.id"
          :post="post"
          class="post"
        >
        <post-thumbnail
          :post="post"
          :updated="updates[post.id]"
        ></post-thumbnail>
          <post-hover
            :post="post"
            :updated="updates[post.id]"
            class="post-hover"
          >
            <post-thumbnail
              :post="post"
              :updated="updates[post.id]"
            ></post-thumbnail>
          </post-hover>
        </link-to-post>
      </div>

      <!-- <div class="posts-grid">
        <post-thumbnail
          v-for="post in postsGroup.posts"
          :post="post"
          class="post"
        ></post-thumbnail>
      </div> -->
    </section>

    <!-- <link-to-post v-for="post in posts" :post="post" class="post">
      <post-thumbnail :post="post"></post-thumbnail>
    </link-to-post> -->

    <!-- <post-thumbnail v-for="post in posts" :post="post" class="post"></post-thumbnail> -->

  </div>
</template>

<script>

import moment from 'moment';

import LinkToPost from '@/components/LinkToPost';
import PostThumbnail from '@/components/PostThumbnail';
import PostHover from '@/components/PostHover';

export default {
  name: 'posts-list',
  components: {
    LinkToPost,
    PostThumbnail,
    PostHover,
  },
  props: {
    posts: {
      type: Array,
      required: true,
    },
    updates: {
      type: Object,
      default: {},
    },
  },
  computed: {
    postsByYears() {
      const cache = {};

      this.posts.forEach((post) => {
        const year = moment(post.created).year();

        cache[year] = cache[year] || [];
        cache[year].push(post);
      });

      return Object.keys(cache)
        // eslint-disable-next-line no-nested-ternary
        .sort((a, b) => (a > b ? -1 : (a === b ? 0 : 1)))
        .map(year => ({
          year,
          posts: cache[year].sort((a, b) => (a.created > b.created ? -1 : 1)),
        }));
    },
  },
};

</script>

<style scoped>

.posts-group {
  margin-bottom: 50px;
}

.posts-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /*justify-content: space-between;*/
}

h2 {
  margin-bottom: 15px;
  margin-left: 10px;
}

.post {
  margin: 0 10px 30px 10px;
  text-decoration: none;
  position: relative;
  width: 200px;
}

.post-hover {
  display: none;
}

.post:hover .post-hover {
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/PostsList.vue